import { Store } from 'src/store/index';

const getClipArtCategory = (store: Store, categoryId: string | number | null) => {
  if (categoryId === null) {
    return undefined;
  }
  return store.addon.clipArtCategories[categoryId];
};

export default getClipArtCategory;
